import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_202: DocMigration = {
  maxSchemaVersion: "0.0.202",
  description: "Rename params to optionSets, paramValues to options, and design to optionChoices",
  apply(json: any) {
    // replace params with optionSets
    if (json.params) {
      json.optionSets = json.params;
      delete json.params;
    }

    // replace design with optionChoices
    if (json.design) {
      json.optionChoices = json.design;
      delete json.design;
    }

    // replace optionSets[id].paramValues with optionSets[id].options
    for (const optionSetId in json.optionSets) {
      const optionSet = json.optionSets[optionSetId];

      // add entityType of "OPTION_SET" to each entry
      optionSet.entityType = "OPTION_SET";

      if (optionSet.paramValues) {
        optionSet.options = optionSet.paramValues;
        delete optionSet.paramValues;
      }
    }

    // replace presets[id].design with presets[id].optionChoices
    for (const presetId in json.presets) {
      const preset = json.presets[presetId];

      if (preset.design) {
        preset.optionChoices = preset.design;
        delete preset.design;
      }
    }

    return json;
  },
};

export default migration_0_0_202;
